import React from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import { cx, csx } from '@vtex/admin-ui'

const CardTitle = ({ i18nTextId, defaultType, largeType, className }) => {
  if (!i18nTextId) return null

  return (
    <div
      className={cx(
        `c-on-base t-${defaultType} ${largeType ? `t-${largeType}-l` : ''}  ${
          className || 'mb5 b'
        }`,
        csx({
          fontFamily: 'VTEX Trust',
        })
      )}
    >
      <FormattedMessage id={i18nTextId} />
    </div>
  )
}

const fontTypes = PropTypes.oneOf([
  'heading-1',
  'heading-2',
  'heading-3',
  'heading-4',
  'heading-5',
  'heading-6',
  'body',
  'small',
  'mini',
])

CardTitle.defaultProps = {
  defaultType: 'heading-4',
}

CardTitle.propTypes = {
  i18nTextId: PropTypes.string,
  className: PropTypes.string,
  defaultType: fontTypes,
  largeType: fontTypes,
}

export default CardTitle
